<template>
  <div class="my-approve">
    <div>
      <el-button v-if="!disabled" type="primary" size="mini" @click="addApprovalDrawer">请选择</el-button>
    </div>
    <div v-if="disabled && !approvalCheckedList.length">--</div>
    <div v-for="item in approvalCheckedList" :key="item.id + 'index'" class="approval-item">
      <div class="approval-item-img">
        <el-image
          v-if="item.processIcon && isNaN(item.processIcon)"
          style="width: 48px; height: 48px"
          :src="item.processIcon"
          fit="contain"
        />
        <svg-icon v-else-if="item.processIcon" :icon-class="`form-icon-${item.processIcon}`" />
        <svg-icon v-else :icon-class="`form-icon-${1}`" />
      </div>
      <div class="approval-item-text">
        <el-tooltip class="item" effect="dark" :content="item.processInstanceTitle" placement="top">
          <p>{{ item.processInstanceTitle }}</p>
        </el-tooltip>
        <p>发起时间：{{ item.startTime }}</p>
      </div>
      <div class="approval-item-state">
        <span :class="`approval-status-now approval-status-now-${item.status}`">{{ item.statusName }}</span>
      </div>
      <div class="approval-item-icon">
        <i v-if="!disabled" class="el-icon-circle-close" @click="deleteHandle(item)" />
      </div>
    </div>
    <div />
    <el-drawer
      title="添加审批流程"
      :visible.sync="drawer"
      size="540px"
      :append-to-body="true"
      :destroy-on-close="false"
      :before-close="closeDrawer"
    >
      <template v-slot:title>
        <div class="search-box">
          <el-input
            v-model="input"
            placeholder="搜索流程编号/流程标题"
            prefix-icon="el-icon-search"
          />
        </div>
      </template>
      <div style="height: 100%">
        <div class="approval-drawer">
          <div v-if="approvalAllList.length < 1" class="no-data">
            无数据
          </div>
          <div class="checkbox-group-box">
            <el-checkbox-group v-model="checkedList" @change="checkedListChange">
              <el-checkbox v-for="item in approvalAllList" :key="item.businessDataKey" :label="item.businessDataKey">
                <div @click.prevent>
                  <div class="approval-content" @click="viewDetials(item)">
                    <el-tooltip class="item" effect="dark" :content="item.processInstanceTitle" placement="top">
                      <p>{{ item.processInstanceTitle }}</p>
                    </el-tooltip>
                    <p>发起时间：{{ item.startTime }}</p>
                  </div>
                  <div class="approval-state">
                    <span :class="`approval-status-now approval-status-now-${item.status}`">{{ item.statusName }}</span>
                  </div>
                </div>
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="approval-drawer-footer">
            <el-button size="mini" @click="closeDrawer">取消</el-button>
            <el-button type="primary" size="mini" @click="confirmDrawer">确定</el-button>
          </div>
        </div>
        <el-drawer
          title="流程详情"
          :append-to-body="true"
          :visible.sync="innerDrawer"
          size="490px"
          :destroy-on-close="true"
          :before-close="closeInnerDrawer"
        >
          <div class="process-details-content">
            <process-details :form-conf="formConf" :form-info="formInfo" />
          </div>
        </el-drawer>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import processDetails from '@/views/processManage/components/processDetails.vue'
import { getFormDetail } from '@/views/approvalCenter/api'
import { getProcessesByProcessKeys, getProcessesByDataKeys } from '@/api/form'
export default {
  name: 'MyApprove',
  components: {
    processDetails
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 配置的流程类型
    approvalType: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 是否只读
    disabled: {
      type: Boolean,
      default: false
    },
    processId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      input: '',
      drawer: false,
      innerDrawer: false,
      formConf: null,
      formInfo: null,
      approvalAllList: [],
      approvalAllList2: [],
      checkedList: [],
      approvalCheckedList: []
    }
  },
  watch: {
    drawer: {
      handler(val) {
        // console.log(val, '-=-=val-=watch', this.value)
        // 每次打开drawer查询搜索一次列表
        if (val) {
          this.search()
          this.checkedList = this.value
        }
      }
    },
    value: {
      handler(arr) {
        if (arr.length) {
          // 根据value查询选中的审批流程
          this.getApprovalCheckedList(arr)
        } else {
          this.approvalCheckedList = []
        }
      },
      immediate: true
    },
    input: {
      handler(val) {
        this.approvalAllList = this.approvalAllList2.filter(item => {
          return item.approvalNo.includes(this.input) || item.processInstanceTitle.includes(this.input)
        })
      }
    }
  },
  created() {},
  mounted() {
  },
  methods: {
    // 配置流程详情
    async getFormDetail() {
      console.log(this.formInfo, 'this.formInfo', this.formInfo.formId)
      const res = await getFormDetail(this.formInfo.formId)
      if (res.code === 200 && res.data) {
        const { content } = res.data
        if (content) {
          this.formConf = content
          if (this.formInfo.formData) {
            const defaultValue = cloneDeep(this.formInfo.formData)
            const modelList = Object.keys(defaultValue)
            const sort = (arr) => {
              arr.forEach((item) => {
                item.bpmConfig.required = false
                if (item.vModel && modelList.includes(item.vModel)) {
                  item.bpmConfig.defaultValue = defaultValue[item.vModel]
                }
                if (item.bpmConfig.children) {
                  sort(item.bpmConfig.children)
                }
              })
              this.formConf.fields = arr
            }
            if (this.formConf.fields) {
              sort(cloneDeep(this.formConf.fields))
            }
          }
        }
        console.log('this.formConf', this.formConf)
      }
    },
    // 监听删除
    deleteHandle(item) {
      // console.log(this.checkedList, '===this.checkedList', this.value)
      this.checkedList = this.value.filter(key => {
        return key !== item.businessDataKey
      })
      this.$emit('input', cloneDeep(this.checkedList))
    },
    addApprovalDrawer() {
      this.drawer = true
    },
    closeDrawer() {
      this.drawer = false
      // // 清除数据
      this.checkedList = []
      this.approvalAllList = []
      this.approvalAllList2 = []
      this.input = ''
    },
    // 监听确定按钮
    confirmDrawer() {
      // console.log(this.checkedList, '-=-=this.checkedList-=-=')
      this.$emit('input', cloneDeep(this.checkedList))
      this.closeDrawer()
    },
    // 初始查询一次
    async search() {
      // console.log(this.approvalType, '-=-=-选择的流程类型-=-')
      const params = {
        processKeys: this.approvalType
      }
      if (this.processId) {
        params.processInstanceId = this.processId
      }
      const res = await getProcessesByProcessKeys(params)
      if (res.code === 200 && res.data) {
        this.approvalAllList = res.data
        this.approvalAllList2 = res.data
      } else {
        this.approvalAllList = []
        this.approvalAllList2 = []
      }
    },
    checkedListChange() {
      // console.log(this.checkedList, '-=-=checkedListChange-=选择的审批流程-=-=-')
    },
    // 阻止checkbox默认事件
    changeEvent(item) {},
    // 点击审批流程名称,查看流程详情
    viewDetials(item) {
      this.innerDrawer = true
      this.formInfo = cloneDeep(item)
      // 查一次流程详情
      this.getFormDetail()
    },
    closeInnerDrawer() {
      console.log('closeInnerDrawer')
      this.innerDrawer = false
      this.formConf = null
      this.formInfo = null
    },
    // 查询选中的审批流程
    async getApprovalCheckedList(arr) {
      const res = await getProcessesByDataKeys(arr)
      if (res.code === 200 && res.data) {
        this.approvalCheckedList = res.data
      } else {
        this.approvalCheckedList = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-button {
  border-color: #2C51EF;
  color: #2C51EF;
  height: 32px;
}
/deep/.el-button--primary {
  color: #fff;
}
.search-box {
  /deep/ .el-input {
    width: 300px;
  }
}
.approval-item {
  display: flex;
  align-items: center;
  margin-top: 16px;
  .approval-item-img {
    width: 48px;
    .svg-icon {
      width: 48px;
      height: 48px;
      vertical-align: middle;
    }
  }
  .approval-item-text {
    margin-right: 20px;
    flex: 1;
    max-width: 220px;
    overflow: hidden;
    p {
      line-height: 24px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .approval-item-state {
    min-width: 58px;
  }
  .approval-item-icon {
    width: 18px;
    font-size: 18px;
    margin-left: 20px;
    cursor: pointer;
  }
}
.approval-drawer {
  height: 100%;
  .no-data {
    color: #999999;
    padding-left: 140px;
    font-size: 14px;
  }
  .checkbox-group-box {
    height: calc(100% - 72px);
    overflow: auto;
    padding: 0 20px;
  }
  .approval-drawer-footer {
    padding: 20px;
    text-align: right;
  }
  .el-checkbox-group {
    display: flex;
    flex-direction: column;
    .el-checkbox {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      width: 360px;
    }
    /deep/.el-checkbox__label {
      width: 100%;
    }
    /deep/.el-checkbox__label > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: default;
      .approval-content {
        width: 250px;
        margin-right: 20px;
        cursor: pointer;
        p {
          line-height: 24px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
.process-details-content {
  padding: 0 20px 20px;
}
// .my-approve {
  .approval-status-now {
    max-height: 28px;
    line-height: 22px;
    padding: 2px 8px;
    border-radius: 2px;
    font-size: 14px;
    word-break: keep-all;
  }
  .approval-status-now-1 {
    background: #EDF9E8;
    color: #00B42A;
  }
  .approval-status-now-2 {
    background: #E3E3E3;
    color: #666666;
  }
  .approval-status-now-3 {
    background: #FFE2E4;
    color: #F54E5A;
  }
  .approval-status-now-4 {
    background: rgba(0,131,255,0.08);
    color: #0083FF;
  }
  .approval-status-now-5, .approval-status-now-0 {
    background: #E3E3E3;
    color: #666666;
  }
// }
</style>
